import { render, staticRenderFns } from "./DialogRequestFriendV2.vue?vue&type=template&id=e6d016e2&scoped=true"
import script from "./DialogRequestFriendV2.vue?vue&type=script&lang=js"
export * from "./DialogRequestFriendV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d016e2",
  null
  
)

export default component.exports